export default class WindowServerData {
    constructor() {
        this.loadEnvs()
    }

    loadEnvs() {
        let envData = {}

        if (window?.serverdata && window.serverdata !== '{{ServerData}}') {
            try {
                const decoded = atob(window.serverdata.trim())
                envData = JSON.parse(decoded)
            } catch (e) {
                console.error('Erro ao decodificar ou parsear serverData', e)
                envData = window.ENV || process.env
            }
        } else if (window?.ENV && Object.keys(window.ENV).length > 0) {
            envData = window.ENV
        } else {
            envData = process.env
        }

        for (const key in envData) {
            this[key] = envData[key]
        }
    }
}

export const envs = new WindowServerData()
